import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import AllEmployeeAddPopup from "../../../../components/modelpopup/AllEmployeeAddPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import EmployeeListFilter from "./../components/EmployeeListFilter";
import { Table, Pagination, Badge } from "antd";
import {
  itemRender,

  pageSizeOptions,
  CustomRow
} from "utils/table";

import { SkeltonLoader } from "components/skeltonLoader";
import FilterDrawer from "components/Drawer/filterDrawer";
import { useEmployee } from "../context/directoryContext";
import Image from "components/Image"
import { formatDateHandler2, isEventUpcoming } from "utils/common";

import { Button } from "components/Button";

const AllEmployee = () => {
  const {
    loading,
    employeeData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleExport,
    handleEmployeeDetailPage,
    handleDateChange,
    exportLoading

  } = useEmployee();
  const navigate = useNavigate();




  const columns = [

    // {
    //   title: "Employee id",
    //   dataIndex: "id",
    //   sorter: true,
    //   // render: (text, record) => (
    //   //   <span className="table-avatar">
    //   //     <Link to="/profile" className="avatar">
    //   //       <img alt="" src={record.image} />
    //   //     </Link>
    //   //     <Link to="/profile">
    //   //       {text} <span>{record.role}</span>
    //   //     </Link>
    //   //   </span>
    //   // ),
    //   // sorter: (a, b) => a.name.length - b.name.length,
    // },
    // {
    //   title: "Employee number",
    //   dataIndex: "emp_no",
    //   sorter: true,
    //   // sorter: (a, b) => a.employee_id.length - b.employee_id.length,
    // },
  
    {
      title: "Name",
      dataIndex: "first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex">
          <a onClick={()=>handleEmployeeDetailPage(record.id, index)} className="avatar">
            {/* <img alt="" src={record.profile_image} /> */}
            <Image src={record.profile_image}  type="user" style={{ objectFit: "cover" }} />
          </a>
          <div>
          <a onClick={()=>handleEmployeeDetailPage(record.id, index)} className="profile-split d-flex flex-column">
            {record.first_name} {record.middle_name} {record.last_name}
             {/* <span>{record?.employment?.position?.name}</span> */}
          </a>
          {record.emp_no && <span className="small text-muted">  { record.emp_no} </span>}
          </div>
        </h2>
      ),

    },
  
  
    {
      title: "Phone",
      dataIndex: "usercontact_company_user__mobile_no",
      sorter: true,
      render: (text, record) => (
        <>
        <a href={`tel:${text}`} className="table-avatar">
          C : {text}
        </a>
        <br/>
        <a href={`tel:${record?.contact?.mobile_no}`}  className="table-avatar">
          P : {record?.contact?.mobile_no}
        </a>
        </>
        
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Email",
      dataIndex: "usercontact_company_user__private_email",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
         {record?.contact?.private_email}
        </span>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Designation",
      dataIndex: "user_employment_company_user__position__name",
      sorter: true,
      render: (data, record) => (
        <div>
        
            
            <div className="dropdown">
              <span className="badge badge-soft-info">{record?.employment?.position?.name}</span>  
            
            </div>
        
        </div>
      ),
      sorter: true,
    },
    // {
    //   title: "Department ",
    //   dataIndex: "department",
    //   sorter: true,
    //   render: (data, record) => (
    //     <div>
    //       {record?.employment?.department && (
    //         <div className="dropdown">
    //           <span className="badge badge-soft-warning">{record?.employment?.department?.name}</span>  
    //           {/* <span class="badge text-bg-secondary">
    //             {record?.employment?.department?.name}
    //           </span> */}
  
        
    //         </div>
    //       )}
    //     </div>
    //   ),
    //   // sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    {
      title: "Report To",
      dataIndex: "user_employment_company_user__report_to",
      sorter: true,
      render: (text, record, index) => (
        <>
      <h2 className="table-avatar d-flex align-items-center">
        <a
          onClick={() => handleEmployeeDetailPage(record?.employment?.report_to?.id, index)}
          className="avatar"
          style={{ width: '40px', height: '40px' }}
        >
          <Image
            src={record?.employment?.report_to?.profile_image}
            type="user"
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        </a>
        <div className="ms-2">
          <a
            onClick={() => handleEmployeeDetailPage(record?.employment?.report_to?.id, index)}
            className="profile-split d-flex flex-column"
          >
            <span>
              {record?.employment?.report_to?.first_name} {record?.employment?.report_to?.last_name}
            </span>
            <span className="small text-muted">
              {record?.employment?.report_to?.position_name}
            </span>
          </a>
          {record?.employment?.report_to?.emp_no && (
            <span className="small text-muted">{record?.employment?.report_to?.emp_no}</span>
          )}
        </div>
      </h2>


        
         </>
      ),

    },
    {
      title: "Employment Date",
      dataIndex: "user_employment_company_user__employment_date",
      sorter: true,
      render: (text, record) => <>{formatDateHandler2(record?.employment?.employment_date)}</>,
  
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      sorter: true,
      render: (text, record) => <>{record?.nationality?.name}</>,
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label">
          <button  className={text ? 'btn btn-white btn-sm badge-outline-success' : 'btn btn-white btn-sm badge-outline-danger'}>
            {text ? "Active" : "Inactive"}
          </button>
        </div>
      ),
      // sorter: (a, b) => a.joindate.length - b.joindate.length,
    },
   
    
  ];

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {employeeData.map((employee, index) => (
            <div className="col-lg-4 col-md-3 col-sm-12 ">
              {
                employee?.is_celeb_birthday &&
                <Badge.Ribbon 
            text={ "Birthday 🎉"} 
            color={"green"}
            placement={"start"}
            size={"small"}
            style={{ zIndex: 1 , position: 'absolute', top: 5, left: -8 }}
            >
              <span></span>
              </Badge.Ribbon>
              }
              {

               isEventUpcoming( employee?.employment?.employment_date) &&
               <Badge.Ribbon 
            text={ "Anniversary 🎉"} 
            color={"yellow"}
            placement={"start"}
            size={"small"}
            style={{ zIndex: 1 , position: 'absolute', top: employee?.is_celeb_birthday ? 30 : 5, left: -8 }}
            >
              <span></span>
            </Badge.Ribbon>
              }
                
            <div className="contact-grid">
                <div className="grid-head">
                    <div className="users-profile">
                        <a onClick={()=>handleEmployeeDetailPage(employee.id, index)} className="avatar">
                            {/* <img src={employee?.profile_image} alt="" /> */}
                            <Image  src={employee?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                        </a>
                        <h5 className="name-user">
                            <a onClick={()=>handleEmployeeDetailPage(employee.id, index)}>{employee?.first_name} {employee?.first_name}</a>
                            <span>{employee?.emp_no}</span>
                        </h5>
                    </div>

                   

                   
                </div>
                <div className="grid-body">
                {/* <div className="table-avatar d-flex align-items-center">
                      <a
                        onClick={() => handleEmployeeDetailPage(employee?.employment?.report_to?.id, index)}
                        className="avatar"
                        style={{ width: '40px', height: '40px' }}
                      >
                        <Image
                          src={employee?.employment?.report_to?.profile_image}
                          type="user"
                          style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                        />
                      </a>
                      <div className="ms-2">
                        <a
                          onClick={() => handleEmployeeDetailPage(employee?.employment?.report_to?.id, index)}
                          className="profile-split d-flex flex-column"
                        >
                          <span>
                            {employee?.employment?.report_to?.first_name} {employee?.employment?.report_to?.last_name}
                          </span>
                          <span className="small text-muted">
                            {employee?.employment?.report_to?.position_name}
                          </span>
                        </a>
                        {employee?.employment?.report_to?.emp_no && (
                          <span className="small text-muted">{employee?.employment?.report_to?.emp_no}</span>
                        )}
                      </div>
                    </div> */}

                    <div className="address-info">
                        <span>
                            <i className="la la-envelope-open" />
                            {employee?.contact?.private_email}
                            {/* sharon@gmail.com */}
                        </span>
                        <span>
                            <i className="la la-phone-volume" />
                            C: {employee?.company_phone_number}
                        </span>
                     
                            {
                              employee?.contact?.mobile_no && (
                                <span>
                                  <i className="ms-3 " />
                                  P : {employee?.contact?.mobile_no}
                                </span>
                              )
                            }
                       
                        <span>
                            <i className="la la-globe" />
                            {employee?.nationality?.name}
                        </span>
                        <span>
                          Report To : <a onClick={()=>handleEmployeeDetailPage(employee?.employment?.report_to?.id, index)} className="text-primary"> {employee?.employment?.report_to?.first_name} {employee?.employment?.report_to?.last_name}</a>
                        </span>
                    </div>
                    <div className="grid-badges">
                        <span className="badge badge-soft-warning">{employee?.employment?.position?.name}</span>
                    </div>
                </div>
                {/* <div className="grid-footer d-flex justify-content-between">
                    <ul className="social-links d-flex align-items-center">
                        <li>
                            <Link to="#">
                                <i className="la la-envelope" />
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <i className="la la-phone-volume" />
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <i className="lab la-facebook-messenger" />
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <i className="la la-skype" />
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <i className="la la-facebook " />
                            </Link>
                        </li>
                    </ul>
                    <div className="set-star">
                        <i className="fa fa-star filled me-2" />
                        4.2
                    </div>
                </div> */}
            </div>
        </div>
           
          ))}
        </>
      );
    }
  };

 



  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Company Directory"
            title="Dashboard"
            subtitle="Company Directory"
            modal="#add_employee"
            name="Add Employee"
            // Linkname="/employees"
            // Linkname1="/employees-list"
            view={view}
            setView={setView}
          />
          <EmployeeListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search employee"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
            handleExport={handleExport}
            exportLoading={exportLoading}
             />

          {view == "grid" ? (
            <div className="row">
              {/* <div className="my-2" >
            <SearchBox handleChange={handleGridChange} pageSettings={pageSettings} setPageSettings={setPageSettings} />
            
            </div> */}
              <GridView />

              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination

                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}

                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                          
                        );
                      }
                      return null;
                    }}

                    />
                  {/* <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    itemRender={itemRender}
                    onChange={handleGridChange}
                  /> */}
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="table-responsive">
                {/* <SearchBox pageSettings={pageSettings} setPageSettings={setPageSettings} /> */}
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={employeeData}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  components={{
                    body: {
                      row: CustomRow, // override row component
                    },
                  }}
                  onRow={(record, index) => ({
                    record, // 👈 injects record into the custom row
                    index,
                  })}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <AllEmployeeAddPopup />
      {/* Delete Modal */}
      <DeleteModal Name="Delete Employee" />

      <FilterDrawer


        searchPlaceholder={"Search employee"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}

        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
      />
      {/* Delete Modal */}
    </div>
  );
};

export default AllEmployee;
